import Vue from 'vue'
import VueCookies from 'vue-cookies'
import api from 'components/util/api'
import util from 'components/util/util'
import { axiosInstance } from 'plugins/axios'
import { Loading, Notify } from 'quasar'
Vue.use(VueCookies)
// Cookie válido por 2 dias
Vue.$cookies.config('2d')
var login = null

// Constantes
const COOKIE_JWT_ACCESS = 'PUB_ACCESS'

const LOCALSTORAGE_CLIENTE = 'PUB_LOCAL_STORAGE_CLIENTE'
const LOCALSTORAGE_APLICACOES = 'PUB_LOCALSTORAGE_APLICACOES'

export default ({ router, store, Vue }) => {
  var helper = {}

  router.beforeEach((to, from, next) => {
    let acessoIndex = window.location.href.indexOf('acesso=')
    if (acessoIndex > 0) {
      // Dados de acesso vindo através da url
      let jwtAccess = window.location.href.substring(acessoIndex + 7)
      let caracteresIndex = jwtAccess.indexOf('#/')
      if (caracteresIndex > 0) {
        // Removendo os carateres adicionados pelo vue no final da URL, '#/'
        jwtAccess = jwtAccess.substring(0, caracteresIndex)
      }
      Vue.$cookies.set(COOKIE_JWT_ACCESS, jwtAccess)
      // redirecionando para a página privada
      helper.buscarAcessos()
    }
    if (!to.fullPath.startsWith('/recadastrarSenha') &&
      to.fullPath !== '/recuperarSenha' &&
      // to.fullPath !== '/' &&
      !helper.getAccessToken()) {
      // Usuário não autenticado
      // URL de redirecionamento para CadUnico
      helper.recuperarLoginUrl((loginUrl) => {
        let redUrl = btoa(window.location.origin)
        let url = loginUrl + '?redirecionar=' + redUrl
        // Abrindo url de login de acesso
        window.open(url, '_self')
      })
    } else {
      helper.atualizarFiltros(to.fullPath)
      next()
    }
  })

  helper.atualizarFiltros = (fullPath) => {
    if (!fullPath.includes('gestaoProcesso') &&
    !fullPath.includes('movimentacaoProcesso') &&
    !fullPath.includes('gestaoSolicitacaoAbertura')) {
      util.adicionarNoStorage('filtroAberturaProcesso', '')
      util.adicionarNoStorage('pesquisarPaginaAbertura', 'N')
    }
    if (!fullPath.includes('gestaoSolicitacaoAbertura')) {
      util.adicionarNoStorage('filtroSolicitacaoAbertura', '')
      util.adicionarNoStorage('pesquisarPaginaSolicitacao', 'N')
    }
  }

  helper.autenticar = (usuario) => {
    var body = new URLSearchParams()
    body.append('username', usuario.desLogin)
    body.append('password', usuario.senha)
    body.append('grant_type', 'password')
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic Y2FkLXVuaWNvLWFwaS1jbGllbnRlOkcwdjNybjRAMjAxOQ==' // Basic Auth: cad-unico-api-cliente/G0v3rn4@2019
      }
    }
    // Enviar requisição de autenticação
    Loading.show()
    axiosInstance.post('/oauth/token', body, config).then(response => {
      helper.setJwtAccess(response.data)
      Notify.create({
        message: 'Usuário autenticado com sucesso',
        type: 'positive',
        icon: 'fas fa-check-circle',
        color: 'green'
      })
      helper.buscarAcessos()
    }).catch(error => {
      helper.tratarErro(error)
    }).finally(() => {
      Loading.hide()
    })
  }
  helper.buscarAcessos = () => {
    let token = helper.getAccessToken()
    if (!token) {
      helper.abrirCadUnico()
    }
    axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token
    let url = '/usuario/acessos/' + api.APLICACAO_GID
    axiosInstance.get(url).then(resposta => {
      let aplicacoes = resposta.data.aplicacoes
      helper.setAplicacoes(aplicacoes)
      let cliente = resposta.data.cliente
      helper.setCliente(cliente)
      // Redirecionar para a página privada inicial
      window.open('/', '_self')
    })
  }
  helper.getAplicacao = () => {
    let aplicacoes = helper.getAplicacoes()

    let aplicacao = aplicacoes.filter(a => a.gidAplicacao === api.APLICACAO_GID)[0]
    return aplicacao
  }
  helper.getPermissoes = () => {
    let aplicacoes = helper.getAplicacoes()
    if (aplicacoes) {
      let aplicacao = aplicacoes.filter(a => a.gidAplicacao === api.APLICACAO_GID)[0]
      let permissoes = []
      aplicacao.perfis.forEach(perfil => {
        permissoes = permissoes.concat(perfil.permissoes)
      })

      const unicos = {}
      permissoes = permissoes.filter(permissao => {
        if (unicos[permissao.codModulo]) return false

        unicos[permissao.codModulo] = true
        return true
      })

      return permissoes
    }
    return null
  }
  helper.atualizarToken = () => {
    var body = new URLSearchParams()
    body.append('grant_type', 'refresh_token')
    let refreshToken = helper.getRefreshToken()
    body.append('refresh_token', refreshToken)
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic Y2FkLXVuaWNvLWFwaS1jbGllbnRlOkcwdjNybjRAMjAxOQ==' // Basic Auth: cad-unico-api-cliente/G0v3rn4@2019
      }
    }
    // Enviar requisição de autenticação
    // Loading.show()
    helper.recuperarLoginUrl((loginUrl) => {
      console.log(loginUrl)
      axiosInstance.post(loginUrl + '/oauth/token', body, config).then(response => {
        // Atualizando token JWT
        helper.setJwtAccess(response.data)
      }).catch(error => {
        helper.tratarErro(error)
      }).finally(() => {
        // Loading.hide()
      })
    })
  }

  helper.tratarErro = (error) => {
    let desMsg = error.message
    if (error.response &&
      error.response.data &&
      error.response.data.error_description === 'Bad credentials') {
      desMsg = 'Senha Inválida'
    }

    if (error.response.data.error_description === 'Login deve ser realizado com CPF/CNPJ') {
      desMsg = 'Login deve ser realizado com CPF/CNPJ'
    }

    if (error.response.data.error_description === 'Usu&aacute;rio inv&aacute;lido') {
      desMsg = 'Usuário Inválido'
    }

    if (error.response.data.error_description === 'Usu&aacute;rio expirado') {
      desMsg = 'Senha Expirada'
    }

    if (error.message === 'Network Error') {
      desMsg = 'Servidor não acessível!'
    }

    Notify.create({
      message: desMsg,
      type: 'warning',
      color: 'orange',
      icon: 'warning'
    })
  }

  helper.autenticado = () => {
    if (!helper.getAccessToken()) {
      return false
    }
    return true
  }
  helper.setJwtAccess = (data) => {
    let jwtAccess = btoa(JSON.stringify(data))
    Vue.$cookies.set(COOKIE_JWT_ACCESS, jwtAccess)
  }
  helper.setAplicacoes = (aplicacoes) => {
    localStorage.setItem(LOCALSTORAGE_APLICACOES, btoa(JSON.stringify(aplicacoes)))
  }
  helper.recuperarLoginUrl = (funcCallback) => {
    axiosInstance.get('/loginUrl').then(resposta => {
      funcCallback(resposta.data)
    })
  }
  helper.abrirCadUnico = () => {
    helper.recuperarLoginUrl((loginUrl) => {
      loginUrl += '/#/aplicacoes'
      window.open(loginUrl, '_self')
    })
  }
  helper.setCliente = (data) => {
    let cliente = btoa(JSON.stringify(data))
    localStorage.setItem(LOCALSTORAGE_CLIENTE, cliente)
  }
  helper.getJwtAccess = () => {
    let jwtAccess = Vue.$cookies.get(COOKIE_JWT_ACCESS)
    if (!jwtAccess) {
      return null
    }
    try {
      let acesso = JSON.parse(atob(jwtAccess))
      return acesso
    } catch (e) {
      Vue.$cookies.set(COOKIE_JWT_ACCESS, null)
    }
    return null
  }

  helper.getCliente = () => {
    let cliente = localStorage.getItem(LOCALSTORAGE_CLIENTE)
    if (!cliente) {
      return null
    }
    var clienteObj = []

    if (atob(cliente) !== 'undefined') {
      clienteObj = JSON.parse(atob(cliente))
    }
    return clienteObj
  }
  helper.getAplicacoes = () => {
    let aplicacoes = localStorage.getItem(LOCALSTORAGE_APLICACOES)
    if (!aplicacoes) {
      // Buscar acessos
      helper.buscarAcessos()
      return null
    }
    var aplicacoesArray = []
    if (atob(aplicacoes) !== 'undefined') {
      aplicacoesArray = JSON.parse(atob(aplicacoes))
    }
    return aplicacoesArray
  }
  helper.sair = () => {
    localStorage.clear()
    helper.recuperarLoginUrl((loginUrl) => {
      let codCliente = 2
      Vue.$cookies.remove(COOKIE_JWT_ACCESS)
      // Vue.$cookies.remove(COOKIE_COD_CLIENTE)
      if (!Number.isNaN(codCliente)) {
        let redUrl = btoa(window.location.origin + '?')
        let url = loginUrl + '/#/sair?redirecionar=' + redUrl
        window.open(url, '_self')
      } else {
        loginUrl = loginUrl + '/#/sair'
        window.open(loginUrl, '_self')
      }
    })
  }
  helper.getAccessToken = () => {
    let access = helper.getJwtAccess()
    if (!access) {
      return null
    }
    return access.access_token
  }
  helper.getRefreshToken = () => {
    let access = helper.getJwtAccess()
    if (!access) {
      return null
    }
    return access.refresh_token
  }
  helper.getDesLogin = (data) => {
    let access = helper.getJwtAccess()
    if (!access) {
      return null
    }
    return access.desLogin
  }
  helper.getCodUsuario = (data) => {
    let access = helper.getJwtAccess()
    if (!access) {
      return null
    }
    return access.codUsuario
  }
  helper.getNomUsuario = (data) => {
    let access = helper.getJwtAccess()
    if (!access) {
      return null
    }
    return access.nomUsuario
  }
  helper.getUsuario = () => {
    let usuario = {
      codUsuario: helper.getCodUsuario(),
      nomUsuario: helper.getNomUsuario()
    }
    return usuario
  }
  Vue.prototype.$login = helper
  Vue.login = helper
  login = helper
}

export { login }
